import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {PaymentService} from "../../services/payment/payment.service";
import {benefitsPageStyles, DebugService} from "../../services/debug.service";
import {ABService} from "../../services/a-b.service";
import {StorageService} from "../../services/storage.service";
import {environment} from "../../../../environments/environment";
import {Dialog} from "primeng/dialog";
import {ToggleSwitch} from "primeng/toggleswitch";
import {FormsModule} from "@angular/forms";
import {SelectButton} from "primeng/selectbutton";
import {ButtonDirective} from "primeng/button";

@Component({
  selector: 'homey-debug-button',
  standalone: true,
  imports: [Dialog, ToggleSwitch, FormsModule, SelectButton, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './debug-button.component.html',
})
export class DebugButtonComponent {
  protected readonly paymentService = inject(PaymentService);
  protected readonly debugService = inject(DebugService);
  protected readonly abService = inject(ABService);
  private readonly storageService = inject(StorageService);
  protected readonly dialogOpen = signal(false);
  protected readonly enabled = environment.debug;

  protected readonly styleOptions = benefitsPageStyles.map(s => ({label: s, value: s}));

  protected async clearStorage() {
    await this.storageService.clear();
    window.location.reload();
  }
}
